export const predefinedAspectRatios = [1, 1.5, 2.86, 3, 3.97, 5.15];

export function calculateAspectRatio(width, height) {
  return width / height;
}

export function getClosestAspectRatio(aspectRatio) {
  return predefinedAspectRatios.reduce((prev, curr) => {
    return Math.abs(curr - aspectRatio) < Math.abs(prev - aspectRatio)
      ? curr
      : prev;
  });
}

export function getAspectRatioClasses(aspectRatio) {
  const aspectRatioClasses = {
    1: {
      classes: "w-48 h-48",
      logoClasses: "max-w-15 md:max-w-20",
      aspectClass: "aspect-1",
    },
    1.5: {
      classes: "w-64 h-48",
      logoClasses: "max-w-15 md:max-w-20",
      aspectClass: "aspect-[1.5]",
    },
    2.86: {
      classes: "max-w-64 h-24",
      logoClasses: "max-w-28 md:max-w-32",
      aspectClass: "aspect-[2.86]",
    },
    3: {
      classes: "max-w-64 h-20",
      logoClasses: "max-w-28 md:max-w-32",
      aspectClass: "aspect-3/1",
    },
    3.97: {
      classes: "max-w-64 h-16",
      logoClasses: "max-w-32 md:max-w-36",
      aspectClass: "aspect-[3.97]",
    },
    5.15: {
      classes: "max-w-64 h-12",
      logoClasses: "max-w-32 md:max-w-36",
      aspectClass: "aspect-[5.15]",
    },
  };

  const matchedRatio = getClosestAspectRatio(aspectRatio);
  return aspectRatioClasses[matchedRatio] || aspectRatioClasses[1];
}
